import { ref } from "vue";

import { useDictStore } from "@/stores/dictStore";
import { InstallationItem } from "@/app/domain/entities/installation";
import { CreateOneStrategy } from "../base/creation.strategy";
import { Pricing } from "../../entities/pricing";
import { ReactiveComponent } from "@/app/domain/entities/base-component";

export class InstallationDiscountCreationStrategy extends CreateOneStrategy {
    constructor(
        installationItemList: InstallationItem[],
    ) {
        const dicts = useDictStore();
        const discountsArray = dicts.getDeliveryDiscountLimits();

        const discountIndex = ref(0);
        const discountSum = ref(0);

        const totalSquare = installationItemList.reduce(
            (acc, item) => +item.qty + acc,
            0,
        );

        const maxDiscount = discountsArray.reduce((max, item) =>
            (item.price_min ?? 0) > (max?.price_min ?? 0) ? item : max,
            discountsArray[0]
        );
        const maxDiscountValue = Math.max(...discountsArray.map(item => item.discount ?? 0));

        const discountValue = discountsArray.find(
            (discount) =>
                totalSquare >= (discount.price_min ?? 0) &&
                totalSquare <= (discount.price_max ?? 0)
        );


        if (totalSquare >= (maxDiscount.price_min ?? 0)) {
            discountIndex.value = maxDiscountValue;
        } else {
            discountIndex.value = discountValue?.discount || 0;
        }

        discountSum.value = discountIndex.value === 0 ? 0 : discountIndex.value * totalSquare;

        const InstallationDiscountConfig = {
            qty: totalSquare,
            price: new Pricing(
                discountIndex.value,
                discountIndex.value,
                discountIndex.value,
            ),
            sum: new Pricing(
                discountSum.value,
                discountSum.value,
                discountSum.value,
            ),
        };

        super(InstallationDiscountConfig, ReactiveComponent);
    }
}

